<script>
  import Section from '../components/Section.svelte';
  import Panel from '../components/Panel.svelte';
  import Alert from '../components/Alert.svelte';
  import Button from '../components/Button.svelte';
  import DataTable from '../components/DataTable.svelte';
  import { session, roleLabels } from '../lib/session.svelte.js';
  import { changePassword } from '../lib/api.js';

  let current = $state('');
  let next = $state('');
  let repeat = $state('');
  let busy = $state(false);
  let error = $state(null);
  let done = $state(false);

  async function submit(event) {
    event.preventDefault();
    error = null;
    done = false;
    if (next !== repeat) { error = 'The new passwords do not match.'; return; }
    busy = true;
    try {
      await changePassword(current, next);
      current = next = repeat = '';
      done = true;
    } catch (e) {
      error = e.message;
    } finally {
      busy = false;
    }
  }
</script>

<h1 class="wf2-title wf2-title-level-1">Your account</h1>

<Section title="Login">
  <Panel>
    <DataTable
      columns={['Field', 'Value']}
      rows={[
        ['Name', session.user?.name],
        ['Email', session.user?.email],
        ['Roles', roleLabels().join(', ')],
      ]}
    />
    <p class="wf2-caption">Logins and roles are managed by your SolidShare operator.</p>
  </Panel>
</Section>

<Section title="Change password">
  <Panel>
    <form class="password-form" onsubmit={submit}>
      <input type="text" autocomplete="username" value={session.user?.email} hidden readonly />
      <label class="wf2-field">Current password
        <input class="wf2-control" type="password" autocomplete="current-password" required bind:value={current} />
      </label>
      <label class="wf2-field">New password (at least 12 characters)
        <input class="wf2-control" type="password" autocomplete="new-password" minlength="12" required bind:value={next} />
      </label>
      <label class="wf2-field">Repeat new password
        <input class="wf2-control" type="password" autocomplete="new-password" minlength="12" required bind:value={repeat} />
      </label>
      {#if error}<Alert title="Password not changed" variant="danger"><p class="wf2-text">{error}</p></Alert>{/if}
      {#if done}<Alert title="Password changed" variant="success"><p class="wf2-text">Other sessions of this login have been signed out.</p></Alert>{/if}
      <div><Button variant="primary" type="submit" disabled={busy}>{busy ? 'Saving…' : 'Change password'}</Button></div>
    </form>
  </Panel>
</Section>

<style>
  .password-form {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    max-width: 360px;
  }
</style>
